import { Module } from 'wrapper6'
import ObjectFitClass from '../utils/_object-fit'

const $ = jQuery

export default class Filters extends Module {
  ready (app) {
    /********************************************
     * SHARED VARS
     ********************************************/

    const LOADER = $('#loader')

    /*
    ***
    ******* News filter loop
    ***
    */

    // Consts

    const NEWS_FILTER = '#post-filter'
    const NEWS_TOGGLE_CONTAINER = $('.mtt-posts-filter.post .page_container')
    const NEWS_DESTINATION = $('.mtt-posts-filter.post .mtt-posts-filter__posts')
    const NEWS_PAGINATION = '.mtt-posts-filter.post #posts-pagination ul li a'
    const NEWS_PAGINATION_DEST = $('.mtt-posts-filter.post #posts-pagination')

    // Lets

    let news_cat = ''
    let news_page_number = 0

    // Filter news posts
    $('.mtt-posts-filter').on('change', NEWS_FILTER, function () {
      news_cat = $(this).find(':selected').val()

      news_page_number = 0

      getNews()
    })

    // Click on pagination
    $(document).on('click', NEWS_PAGINATION, function (e) {
      // Prevent default link behavior
      e.preventDefault()

      // Update page number
      news_page_number = $(this).attr('data-page')

      // Run ajax request
      getNews()
    })

    // Ajax request function
    function getNews () {
      // Show loader
      LOADER.addClass('show')

      // Animate body to top
      if ($(window).width() > 600) {
        $('html, body').animate({
          scrollTop: NEWS_TOGGLE_CONTAINER.offset().top - 150
        }, 500)
      } else {
        $('html, body').animate({
          scrollTop: NEWS_DESTINATION.offset().top - 60
        }, 500)
      }

      // Set ajax data
      const data = {
        action: 'filter_news',
        cat: news_cat,
        page_number: news_page_number,
        url: window.location.href
      }

      // Ajax call
      jQuery.post(main_theme_objects.ajax_url, data, function (response) {
        if (response != 0) {
          // Post response
          if (response.posts !== '') {
            NEWS_DESTINATION.html(response.posts)
            NEWS_DESTINATION.append('<div class="filler"> </div>')
            NEWS_DESTINATION.append('<div class="filler"> </div>')
          } else {
            NEWS_DESTINATION.html('<p class="no-posts">' + NEWS_DESTINATION.attr('data-no-posts') + '</p>')
          }

          new ObjectFitClass()

          // Pagination response
          NEWS_PAGINATION_DEST.html(response.pagination)

          // Hide loader
          LOADER.removeClass('show')
        }
      })
    }

    /*
    ***
    ******* Applications filter loop
    ***
    */

    // Consts

    const APPLICATIONS_FILTER = '#applications-filter'
    const APPLICATIONS_TOGGLE_CONTAINER = $('.mtt-posts-filter.applications .page_container')
    const APPLICATIONS_DESTINATION = $('.mtt-posts-filter.applications .mtt-posts-filter__posts')
    const APPLICATIONS_PAGINATION = '.mtt-posts-filter.applications #posts-pagination ul li a'
    const APPLICATIONS_PAGINATION_DEST = $('.mtt-posts-filter.applications #posts-pagination')

    // Lets

    let applications_cat = ''
    let applications_page_number = 0

    // Filter news posts
    $('.mtt-posts-filter').on('change', APPLICATIONS_FILTER, function () {
      applications_cat = $(this).find(':selected').val()

      applications_page_number = 0

      getApplications()
    })

    // Click on pagination
    $(document).on('click', APPLICATIONS_PAGINATION, function (e) {
      // Prevent default link behavior
      e.preventDefault()

      // Update page number
      applications_page_number = $(this).attr('data-page')

      // Run ajax request
      getApplications()
    })

    // Ajax request function
    function getApplications () {
      // Show loader
      LOADER.addClass('show')

      // Animate body to top
      if ($(window).width() > 600) {
        $('html, body').animate({
          scrollTop: APPLICATIONS_TOGGLE_CONTAINER.offset().top - 150
        }, 500)
      } else {
        $('html, body').animate({
          scrollTop: APPLICATIONS_DESTINATION.offset().top - 60
        }, 500)
      }

      // Set ajax data
      const data = {
        action: 'filter_applications',
        cat: applications_cat,
        page_number: applications_page_number,
        url: window.location.href
      }

      // Ajax call
      jQuery.post(main_theme_objects.ajax_url, data, function (response) {
        if (response != 0) {
          // Post response
          if (response.posts !== '') {
            APPLICATIONS_DESTINATION.html(response.posts)
            APPLICATIONS_DESTINATION.append('<div class="filler"> </div>')
            APPLICATIONS_DESTINATION.append('<div class="filler"> </div>')
          } else {
            APPLICATIONS_DESTINATION.html('<p class="no-posts">' + APPLICATIONS_DESTINATION.attr('data-no-posts') + '</p>')
          }

          new ObjectFitClass()

          // Pagination response
          APPLICATIONS_PAGINATION_DEST.html(response.pagination)

          // Hide loader
          LOADER.removeClass('show')
        }
      })
    }

    /*
    ***
    ******* Events filter
    ***
    */

    // Consts

    const EVENTS_FILTER = '#events-filter'
    const EVENTS_TOGGLE_CONTAINER = $('.mtt-posts-filter.events .page_container')
    const EVENTS_DESTINATION = $('.mtt-posts-filter.events .mtt-posts-filter__posts')
    const EVENTS_PAGINATION = '.mtt-posts-filter.events #posts-pagination ul li a'
    const EVENTS_PAGINATION_DEST = $('.mtt-posts-filter.events #posts-pagination')

    // Lets

    let events_cat = ''
    let events_page_number = 0

    // Filter news posts
    $('.mtt-posts-filter').on('change', EVENTS_FILTER, function () {
      events_cat = $(this).find(':selected').val()

      events_page_number = 0

      getEvents()
    })

    // Click on pagination
    $(document).on('click', EVENTS_PAGINATION, function (e) {
      // Prevent default link behavior
      e.preventDefault()

      // Update page number
      events_page_number = $(this).attr('data-page')

      // Run ajax request
      getEvents()
    })

    // Ajax request function
    function getEvents () {
      // Show loader
      LOADER.addClass('show')

      // Animate body to top
      if ($(window).width() > 600) {
        $('html, body').animate({
          scrollTop: EVENTS_TOGGLE_CONTAINER.offset().top - 150
        }, 500)
      } else {
        $('html, body').animate({
          scrollTop: EVENTS_DESTINATION.offset().top - 60
        }, 500)
      }

      // Set ajax data
      const data = {
        action: 'filter_events',
        cat: events_cat,
        page_number: events_page_number,
        url: window.location.href
      }

      // Ajax call
      jQuery.post(main_theme_objects.ajax_url, data, function (response) {
        if (response != 0) {
          // Post response
          if (response.posts !== '') {
            EVENTS_DESTINATION.html(response.posts)
            EVENTS_DESTINATION.append('<div class="filler"> </div>')
            EVENTS_DESTINATION.append('<div class="filler"> </div>')
          } else {
            EVENTS_DESTINATION.html('<p class="no-posts">' + EVENTS_DESTINATION.attr('data-no-posts') + '</p>')
          }

          new ObjectFitClass()

          // Pagination response
          EVENTS_PAGINATION_DEST.html(response.pagination)

          // Hide loader
          LOADER.removeClass('show')
        }
      })
    }
  }
}
